import { Flex, Tag } from "antd"
import styles from "./index.module.css"
import PropTypes from "prop-types"

const GroupProfileTags = ({ groups }) => {
  if (!groups?.length) return null

  return (
    <Flex wrap="wrap" gap={10}>
      {groups.map((group) => {
        const { id, color, name } = group || {}
        return (
          <Tag className={`px-s mr-0 py-xxs ellipsis ${styles.tag}`} key={id} style={{ color: color, backgroundColor: color + "26" }}>
            {name}
          </Tag>
        )
      })}
    </Flex>
  )
}

GroupProfileTags.propTypes = {
  groups: PropTypes.array
}

export default GroupProfileTags
